// `failed: true` marks a placeholder for a variable whose backend chunk failed (see
// buildFailedPlaceholder in the data-service controller) - never real data. Both
// /variables/last and /variables/series responses carry this marker.
function isFailedValue(value) {
  return value?.failed === true;
}

function getFailedVariableIds(values) {
  return [
    ...new Set(values.filter((value) => isFailedValue(value)).map((value) => value.variable)),
  ];
}

// A chunk failure on the backend is usually transient (e.g. a momentary statement timeout under
// load) - retry silently a couple of times before leaving the failure in place, rather than
// surfacing an error for something that often self-heals almost immediately.
const FAILED_VARIABLE_RETRY_DELAYS_MS = [1000, 3000];

export { isFailedValue, getFailedVariableIds, FAILED_VARIABLE_RETRY_DELAYS_MS };
